exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".siteAnnoucementModal .titleImgeContainer{display:flex;justify-content:space-around;gap:1em;flex-wrap:wrap;align-items:center;margin:2em 0}.siteAnnoucementModal .titleImage{max-width:100%}.siteAnnoucementModal .titleImage.savvasLogo{height:55px}.siteAnnoucementModal .titleImage.wrLogo{height:45px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/notifications/site_annoucement_modal.scss
// module id = 1350
// module chunks = 0